module.exports = __webpack_public_path__ + "img/oceanShipping-N.4fcc05cc.png";